































































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { throttle } from 'lodash-es';
import { PropType } from 'vue';
import { typeTypoModel } from '../types';
import { getTextSize } from '../utils';
import TtamAdTextTypoModel from '../typo-model/index.vue';
import { stringLength, getAfterPasteText, isExistEscapeChar, removeEscapeChar } from '@tt4b/ttam-utils';

const name = 'ttam-ad-text-textarea';
export default defineComponent({
  name,
  components: {
    TtamAdTextTypoModel,
  },
  props: {
    domId: {
      type: String,
      default: '',
    },
    // title文案
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 3,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    resize: {
      type: String,
      default: 'none',
    },
    inputClass: {
      type: String,
      default: '',
    },
    // 是否使用错别字识别模型
    useTypoModel: {
      type: Boolean,
      default: false,
    },
    // 错别字模型
    typoModel: {
      type: Array as PropType<typeTypoModel[]>,
      default: () => [],
    },
    useCount: {
      type: Boolean,
      default: false,
    },
    isValidateSuccess: {
      type: Boolean,
      default: true,
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    throttleTime: {
      type: Number,
      default: 300,
    },
    // textarea默认只展示一行，超过多大宽度则换行
    newLineWidth: {
      type: Number,
      default: 350,
    },
    // 是否展示删除按钮
    showDeleteIcon: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onlyOneLine = ref(true);
    const computedStringLength = computed(() => stringLength(props.value));
    const handleTextSize = val => {
      if (getTextSize(val)?.width >= props.newLineWidth) {
        onlyOneLine.value = false;
      } else {
        onlyOneLine.value = true;
      }
    };
    const titleInput = ref();
    const throttleHandleTextSize = throttle(handleTextSize, props.throttleTime);
    // 使用watch主要是解决，刚开始时需要默认计算一次
    watch(
      () => props.value,
      val => {
        throttleHandleTextSize(val);
      },
      {
        immediate: true,
      },
    );
    const handleTextInput = val => {
      emit('input', val);
    };
    const handleFocus = () => {
      emit('focus');
    };
    const handleBlur = () => {
      emit('blur');
    };
    const handleClick = () => {
      emit('click');
    };
    const handleKeydown = () => {
      emit('keydown');
    };
    const handleRecheck = () => {
      emit('recheck');
    };
    const handleDelete = () => {
      emit('delete');
    };
    /**
     * 粘贴文案时，存在转义字符，则自动过滤转义字符
     */
    const handlePaste = event => {
      try {
        const clipboardData = event.clipboardData || (window as any).clipboardData;
        let pasteText: string = clipboardData.getData('text') || '';

        // 含有转义字符则移除转义字符，否则使用默认复制操作，不进行处理
        if (pasteText && isExistEscapeChar(pasteText)) {
          // 禁用默认复制逻辑
          event.preventDefault();
          pasteText = removeEscapeChar(pasteText);

          const finalText = getAfterPasteText(event.target, pasteText);
          // 把处理好的最终显示文本，emit input事件出去，触发v-model绑定的值
          handleTextInput(finalText);
        }
      } catch (error) {}
    };
    return {
      name,
      onlyOneLine,
      computedStringLength,
      titleInput,
      handleTextInput,
      handleFocus,
      handleBlur,
      handleClick,
      handleKeydown,
      handleRecheck,
      handleDelete,
      handlePaste,
    };
  },
});
